/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestionnaireAnswer
 */
export interface QuestionnaireAnswer {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireAnswer
     */
    questionId: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireAnswer
     */
    possibleAnswerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireAnswer
     */
    answerText?: string | null;
}

/**
 * Check if a given object implements the QuestionnaireAnswer interface.
 */
export function instanceOfQuestionnaireAnswer(value: object): value is QuestionnaireAnswer {
    if (!('questionId' in value) || value['questionId'] === undefined) return false;
    return true;
}

export function QuestionnaireAnswerFromJSON(json: any): QuestionnaireAnswer {
    return QuestionnaireAnswerFromJSONTyped(json, false);
}

export function QuestionnaireAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionnaireAnswer {
    if (json == null) {
        return json;
    }
    return {
        
        'questionId': json['questionId'],
        'possibleAnswerId': json['possibleAnswerId'] == null ? undefined : json['possibleAnswerId'],
        'answerText': json['answerText'] == null ? undefined : json['answerText'],
    };
}

export function QuestionnaireAnswerToJSON(json: any): QuestionnaireAnswer {
    return QuestionnaireAnswerToJSONTyped(json, false);
}

export function QuestionnaireAnswerToJSONTyped(value?: QuestionnaireAnswer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questionId': value['questionId'],
        'possibleAnswerId': value['possibleAnswerId'],
        'answerText': value['answerText'],
    };
}

